import type IMethodosRepository from '@/core/domain/emethodos/IMethodosRepository.ts'

export default class FetchAllEMethodosUseCase {
  private readonly eMethodosRepository: IMethodosRepository

  constructor(eMethodosRepository: IMethodosRepository) {
    this.eMethodosRepository = eMethodosRepository
  }
  async execute() {
    return await this.eMethodosRepository.fetchAllEMethodos()
  }
}
